
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { cn } from "@/lib/utils";

interface ImageCarouselProps {
  images: string[];
  alt?: string;
  className?: string;
}

const ImageCarousel = ({ images, alt = "Provider image", className = "" }: ImageCarouselProps) => {
  if (!images || images.length === 0) {
    // fallback gradient if no images
    return (
      <div className={cn("relative h-48 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg", className)}>
        <div className="absolute inset-0 bg-black/20 rounded-lg"></div>
      </div>
    );
  }

  if (images.length === 1) {
    return (
      <div className={cn("relative h-48 rounded-lg overflow-hidden", className)}>
        <img
          src={images[0]}
          alt={alt}
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-black/10"></div>
      </div>
    );
  }

  const handleCarouselClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div className={cn("relative h-48 rounded-lg overflow-hidden", className)}>
      <Carousel className="w-full h-full" onClick={handleCarouselClick}>
        <CarouselContent className="h-full">
          {images.map((img, idx) => (
            <CarouselItem key={idx} className="h-full">
              <div className="relative h-48 w-full">
                <img
                  src={img}
                  alt={alt}
                  className="h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-black/10"></div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white border-none shadow-lg" />
        <CarouselNext className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white border-none shadow-lg" />
      </Carousel>
    </div>
  );
};

export default ImageCarousel;
